<template>
  <div id="tax-history" class="table-responsive">
    <table
      class="table table-sm table-striped table-hover table-bordered ledger"
    >
      <thead>
        <tr>
          <th scope="col">Pay Year</th>
          <th scope="col">Spring</th>
          <th scope="col">Fall</th>
          <th scope="col">Delinquencies</th>
          <th scope="col">Total Tax</th>
          <th scope="col">Payments</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="6" class="text-center text-muted p-3">
            No data
          </td>
        </tr>
        <tr v-for="item in items" v-bind:key="item.PayYear">
          <th scope="row">
            <a
              v-if="item.PayYear !== parcelPayYear"
              :href="payYearLink(item.PayYear)"
              rel="noopener"
              target="_blank"
              >{{ item.PayYear }}</a
            >
            <p v-else class="m-0">{{ item.PayYear }}</p>
          </th>
          <td>{{ item.SpringTax | currency }}</td>
          <td>{{ item.FallTax | currency }}</td>
          <td>{{ item.Delinquencies | currency }}</td>
          <td>{{ item.TotalTax | currency }}</td>
          <td>{{ item.Payments | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  methods: {
    payYearLink(year) {
      return `${process.env.BASE_URL}${this.countySlug}/${this.$route.params.dup}-${year}`;
    },
  },
  computed: {
    parcelPayYear() {
      return this.$route.params.payYear || this.items[0].PayYear;
    },
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    countySlug: {
      type: String,
      required: true,
    },
  },
};
</script>
